import { render, staticRenderFns } from "./ContractsView.vue?vue&type=template&id=c847274c&scoped=true&"
import script from "./ContractsView.vue?vue&type=script&lang=js&"
export * from "./ContractsView.vue?vue&type=script&lang=js&"
import style0 from "./ContractsView.vue?vue&type=style&index=0&id=c847274c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c847274c",
  null
  
)

export default component.exports